// extracted by mini-css-extract-plugin
module.exports = {"cta":"_K","cta__pageLink":"_L"};